import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_PRODUCT_TYPE_DEF,
} from "./actionTypes"

import {
  getProductTypeDefListSuccess,
  productTypeDefApiError
} from "./actions"

import {
  getAllProductType,
} from "../../helpers/backend_helper/backend_helper"

function* onGetProductTypeDefList() {
  try {
    const response = yield call(getAllProductType)
    yield put(getProductTypeDefListSuccess(response))
  } catch (error) {
    yield put(productTypeDefApiError(error))
  }
}

function* productTypeDefSaga() {
    yield takeEvery(GET_PRODUCT_TYPE_DEF,onGetProductTypeDefList)
}

export default productTypeDefSaga